import React from 'react';
import {VideoOrFallbackImage} from '../../atoms/VideoOrFallbackImage/VideoOrFallbackImage';
import {FullWidthImage} from '../../molecules/FullWidthImage/FullWidthImage';
import {SlideAmbientProps} from './types';

export const SlideFullWidthImageOrVideo: React.FC<
  Pick<
    SlideAmbientProps,
    'customSlideImage' | 'slideImage' | 'slideVideo' | 'isCloseToViewport'
  > & {
    ['data-testid']?: string;
    className?: string;
  }
> = ({
  className,
  'data-testid': dataTestId,
  customSlideImage, // used for htc and campaign slides
  slideImage,
  slideVideo,
  isCloseToViewport,
}) => {
  if (customSlideImage) {
    return <>{customSlideImage}</>;
  }

  return (
    <VideoOrFallbackImage
      className={className}
      video={slideVideo}
      loading={isCloseToViewport ? 'eager' : 'lazy'}
      image={
        slideImage ? (
          <FullWidthImage
            dataTestId={dataTestId}
            className={className}
            imageUrl={slideImage.url}
            description={slideImage.description}
            aspectRatio="2:1"
            highPrioImage={isCloseToViewport}
            disableFixedRatio
            imagePosition="top"
          />
        ) : null
      }
    />
  );
};
